export const list = {
  listStyleType: {
    scale: true,
  },
  listStylePosition: {
    scale: true,
  },
  listStyleImage: {
    scale: true,
  },
} as const;
/**
 * NextJS 12.2.5 does not support `satisfies` assertion
 * Once we upgrade NextJS, these should be `as const satisfies ScaleObject`
 */

export type List = typeof list;
